const groups = {
  ADMIN: 1,
  PARTNER: 2,
};

export default groups;
